"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactComponents = require("@ui-propulsion/react-components");
var useStyles = (0, _reactComponents.makeStylesPropulsion)(function (theme) {
  var palette = theme.palette,
    typography = theme.typography;
  var fontFamilyRegular = typography.fontFamilyRegular,
    pxToRem = typography.pxToRem;
  return {
    root: {
      fontFamily: fontFamilyRegular,
      color: palette.denim[500]
    },
    fieldWrap: {
      marginBottom: pxToRem(24)
    },
    imageWrap: {
      width: pxToRem(343),
      maxWidth: '100%',
      marginBottom: pxToRem(24),
      '& img': {
        width: '100%'
      }
    }
  };
}, {
  name: 'PlaidVerifyRouting'
});
exports.useStyles = useStyles;
